import FlooPlan1 from "@/assets/images/floorplan/1.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";
import Lighting1 from "@/assets/images/lighting/Lighting.png";

export const takeoffServices = [
  {
    id: 1,
    title: 'Proposal Building',
    description: 'Comprehensive material quantity takeoffs with detailed cost estimation for construction projects. Includes lumber, concrete, steel, finishes, and all building materials with accurate measurements and pricing.',
    image: FlooPlan1,
    icon: 'ri-file-list-3-line',
    tags: ['Quantity Surveying', 'Cost Estimation', 'Material Lists', 'Budget Planning'],
    features: [
      'Detailed material quantities',
      'Cost breakdown analysis',
      'Supplier pricing integration',
      'Waste factor calculations'
    ]
  },
  {
    id: 2,
    title: 'Cost Estimation',
    description: 'Accurate labor hour calculations and workforce planning for construction projects. Detailed analysis of man-hours required, crew sizing, and project timeline estimation based on industry standards.',
    image: LineDiagram2,
    icon: 'ri-calculator-line',
    tags: ['Labor Analysis', 'Time Management', 'Crew Planning', 'Productivity Rates'],
    features: [
      'Man-hour calculations',
      'Crew size optimization',
      'Timeline projections',
      'Productivity analysis'
    ]
  },
  {
    id: 3,
    title: 'System Design',
    description: 'Complete project cost analysis including materials, labor, equipment, and overhead. Detailed budget breakdowns with contingency planning and value engineering recommendations for optimal project economics.',
    image: Lighting1,
    icon: 'ri-ruler-2-line',
    tags: ['Budget Planning', 'Cost Control', 'Value Engineering', 'Financial Analysis'],
    features: [
      'Complete cost breakdowns',
      'Budget vs actual tracking',
      'Value engineering options',
      'Contingency planning'
    ]
  }
];

